import { A2kSelect } from "./A2kSelect";
window.customElements.define("a2k-select", A2kSelect);
